import * as PIXIParticleEmitter from "@pixi/particle-emitter";
/**
 * ParticleEmitter.ts
 */
export class ParticleEmitter {
    constructor(container, properties) {
        this.properties = properties;
        this.emitter = new PIXIParticleEmitter.Emitter(container, PIXIParticleEmitter.upgradeConfig(properties.getConfig(), properties.getImages()));
    }
    start() {
        this.emitter.emit = true;
    }
    stop() {
        this.emitter.emit = false;
    }
    update(delta) {
        this.emitter.update(delta);
    }
    cleanup() {
        this.emitter.cleanup();
    }
    destroy() {
        this.emitter.destroy();
    }
    getEmitter() {
        return this.emitter;
    }
}
//# sourceMappingURL=ParticleEmitter.js.map